import _ from 'underscore';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const BodyOverflowContext = React.createContext([[], _.noop]);

const BodyOverflowProvider = (props) => {
	const [overflowKeys, setOverflowKeys] = useState([]);

	const toggleOverflow = useCallback(
		(name, isHidden) => {
			const newOverflowKeys = isHidden
				? _(overflowKeys).union([name])
				: _(overflowKeys).without(name);

			setOverflowKeys(newOverflowKeys);
		},
		[overflowKeys.length]
	);

	useEffect(() => () => document.body.classList.remove('overflow'), []);

	useEffect(() => {
		if (overflowKeys.length) {
			document.body.classList.add('overflow');
		} else {
			document.body.classList.remove('overflow');
		}
	}, [overflowKeys.length]);

	return (
		<BodyOverflowContext.Provider
			value={[Boolean(overflowKeys.length), toggleOverflow]}
		>
			{props.children}
		</BodyOverflowContext.Provider>
	);
};

BodyOverflowProvider.propTypes = {
	children: PropTypes.node.isRequired
};

export { BodyOverflowContext, BodyOverflowProvider };
